import {MessagesPage} from "./presentation/MessagesPage";
import React from "react";
import {useMessages} from "./useMessages";

export const MessagesContainer = () => {
    return <MessagesPage data={useMessages()} />
}
